import { render, staticRenderFns } from "./email_field.vue?vue&type=template&id=6360e261&lang=pug&"
import script from "./email_field.vue?vue&type=script&lang=js&"
export * from "./email_field.vue?vue&type=script&lang=js&"
import style0 from "./email_field.vue?vue&type=style&index=0&id=6360e261&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports